import { createContext } from 'react';

import type { AnnotationsChartConfigProperties } from '../types/annotations-chart-config-props.js';

/**
 * @internal
 */
export const AnnotationsChartConfigContext = createContext<
  AnnotationsChartConfigProperties | string
>({});

/**
 * Provider for the AnnotationsChart API config that can be shared across charts
 * @public
 */
export const AnnotationsChartConfig = AnnotationsChartConfigContext.Provider;
